<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="转换信息" name="1" v-show="detail.cluesStatus === 2">
      <el-row class="panel-item">
        <el-col :span="11">
          <label>客户名称</label>
          <span
            class="link"
            @click="toDetail"
            v-if="
              customAuth.customerDetailTab && customAuth.customerDetailTab.toggleStatus
            "
            >{{ detail.customerName || "--" }}</span
          >
          <span v-else>{{ detail.customerName || "--" }}</span>
        </el-col>
      </el-row>
    </el-collapse-item>
    <el-collapse-item title="基本信息" name="2">
      <info-item
        :title="['姓名', '公司']"
        :data="[detail.name, detail.companyName]"
      ></info-item>
      <info-item
        :title="['部门', '职务']"
        :data="[detail.department, detail.duty]"
      ></info-item>
      <info-item
        :title="['来源', '联系方式']"
        :data="[detail.cluesSourceName, detail.mobile]"
      ></info-item>
      <info-item
        :title="['意向', '状态']"
        :data="[detail.intention, statusFilter(detail.cluesStatus)]"
      ></info-item>
      <info-item
        :title="['地区', '详细地址']"
        :data="[
          `${detail.province}${detail.city ? '-' + detail.city : ''}${
            detail.district ? '-' + detail.district : ''
          }`,
          detail.streetAddress,
        ]"
      ></info-item>
      <info-item
        :title="['业务员', '业务员所属部门']"
        :data="[detail.salesmanName, detail.teamName]"
      ></info-item>
      <info-item :title="['线索无效原因']" :data="[detail.invalidReasonName]"></info-item>
      <info-item :title="['备注']" :data="[detail.content]"></info-item>
    </el-collapse-item>
    <el-collapse-item title="系统信息" name="3">
      <info-item
        :title="['创建人', '创建时间']"
        :data="[detail.createdName, timeChange(detail.gmtCreated)]"
      ></info-item>
      <info-item
        :title="['最后修改人', '最后修改时间']"
        :data="[detail.modifiedName, timeChange(detail.gmtModified)]"
      ></info-item>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { formatTimeShow } from "@/scripts/utils";
import InfoItem from "@/components/base/detail-info-item.vue";

export default {
  props: {
    detail: Object,
  },
  components: {
    InfoItem,
  },
  data() {
    return {
      activeNames: ["1", "2", "3"],
      auth: {},
    };
  },
  // created() {
  //   const { data } = this.getAuthority({ menuUrl: '/custome' })
  //   console.log(data)
  // },
  mounted() {
    this.getAuthority({ menuUrl: "/customer/valid" });
  },
  computed: {
    ...mapGetters({
      customAuth: "authority/customAuth",
    }),
  },
  methods: {
    ...mapActions({
      getAuthority: "authority/getAuthority",
    }),
    toDetail() {
      this.$emit("toDetail");
    },
    statusFilter(val) {
      const list = [
        {
          label: "待处理",
          value: 0,
        },
        {
          label: "跟进中",
          value: 1,
        },
        {
          label: "已转换",
          value: 2,
        },
        {
          label: "失效",
          value: 3,
        },
        {
          label: "其他",
          value: 4,
        },
      ];
      const target = list.find((item) => item.value === val);
      return target ? target.label : "";
    },
    timeChange(val) {
      return formatTimeShow(val);
    },
  },
};
</script>

<style lang="less">
@import "~@/styles/common.less";

.panel-item {
  padding: 0 10px;
  label {
    width: 150px;
    display: inline-block;
    color: @color--info;
  }
  &:last-child {
    .el-col {
      border: none;
    }
  }
}
</style>
